<div class="agpr-blockForm">
    <ng-template #formFieldsContainer></ng-template>
    @if (hasNoFields) {
        <agpr-message [severity]="messageSeverityEnum.noContent">
            {{ 'PageBuilder.blockForm.noSettings' | localize }}
        </agpr-message>
    }
</div>
